import React, {
  useState,
  useRef,
  useEffect,
} from "react";
import {
  Box,
  Button,
  Chip,
  Container,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import { DeleteIconRenderer } from "../../App/GridRenderers.jsx";

import { moneyFormatter } from "../../App/GridFormatters.jsx";
import {
  getOptions,
  putOptions,
  AccountUrl_get,
  AccountUrl_put,
  ftchPlus,
  empty_uuid,
} from "../../App/Account_urls.jsx";

import { AddDialog } from "../../Components/AddDialog.jsx";
import { InputAge } from "../../Components/Inputs/Input_Age.jsx";
import { InputPercentage } from "../../Components/Inputs/Input_Percentage.jsx";
import { InputMoney } from "../../Components/Inputs/Input_Money.jsx";
import { errorClear, errorJsonHasErrors, errorSet, errorSetPlus } from "../../Components/Inputs/Input_Fns.jsx";

import { set } from "lodash";
import { InputCheck } from "../../Components/Inputs/Input_Check.jsx";
import { InputYear } from "../../Components/Inputs/Input_Year.jsx";
import { InputSelect1, InputSelectMonth, InputSelectN } from "../../Components/Inputs/Select.jsx";
import { autoSizeStrategy } from "../../Pages/GridScenario.jsx";
import { useCallback } from "react";



const TaxInput = ({ avail, Tax, onChange, index, birthYear, client, onError }) => {
  const [form, setForm] = useState(Tax);
  const [errors, setErrors] = useState({})


  useEffect(() => { }, [client]);

  const onChange_any = (n, v) => {
    let nf = { ...form, [n]: v, };
    setForm(nf);
    onChange(nf);
  }
  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value)
  };



  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }

  return (
    <Box sx={{ width: 1227, my: 2, p: 2, border: "1px solid grey" }}>
      <Stack spacing={2} sx={{ my: 2 }}>
        <Typography id="who" variant="h6" gutterBottom>
          Tax
        </Typography>

        {/* <InputCheck
          label="2024 Capital Gains: Use 50% only"
          name="CG2024Use50Only"
          value={form.CG2024Use50Only}
          onChange={onChange_any}
        /> */}
        <InputYear
          label="Max Tax Year"
          name="MaxYear"
          year={form.MaxYear}
          birthYear={birthYear}
          width={160}
          minAge={2021 - birthYear}
          required={false}
          maxAge={new Date().getFullYear() - birthYear}
          onChange={onChange_t}
        />

      </Stack >
    </Box >
  );
};



const InfInput = ({ Inf, onChange, onError }) => {
  const [form, setForm] = useState(Inf);
  const [errors, setErrors] = useState({})

  const onChange_t = (e) => {
    let nf = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nf);
    onChange(nf);
  };

  const onChange_any = (n, v) => {
    let nf = { ...form, [n]: v, };
    setForm(nf);
    onChange(nf);
  }

  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }
  console.log(Inf)
  return (
    <Stack spacing={2} >
      <Box sx={{ width: 300, my: 2, p: 2, border: "1px solid grey" }}>
        <Stack spacing={2} sx={{ my: 2 }}>
          <Typography id="who" variant="h6" gutterBottom>
            Inflation
          </Typography>

          <Stack direction="row" spacing={2} >
            <InputPercentage
              label={"Wage Inflation Real %"}
              name="WageInflationReal"
              percent={form.WageInflationReal}
              onChange={onChange_t}
              min={0}
              max={10}
              width={200}
              onError={(e) => myError("wageInflationReal", null, e)}
            />
          </Stack>
        </Stack >
      </Box >
    </Stack >
  );
};


const OASInput = ({ avail, Oas, onChange, index, client, onError }) => {
  const [form, setForm] = useState(Oas);
  const [errors, setErrors] = useState({})

  useEffect(() => { }, [client]);

  const onChange_t = (e) => {
    let nf = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nf);
    onChange(nf);
  };

  const onChange_any = (n, v) => {
    let nf = { ...form, [n]: v, };
    setForm(nf);
    onChange(nf);
  }

  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }

  return (
    <Stack spacing={2} >
      <Box sx={{ width: 300, my: 2, p: 2, border: "1px solid grey" }}>
        <Stack spacing={2} sx={{ my: 2 }}>
          <Typography id="who" variant="h6" gutterBottom>
            OAS
          </Typography>

          <Stack direction="row" spacing={2} >
            <Box>
              <Typography sx={{ mt: 2 }} variant="body2" >
                Start
              </Typography>
            </Box>
            <InputAge
              label={"Age"}
              name="StartAge"
              age={form.StartAge}
              onChange={onChange_t}
              min={65}
              max={70}
              onError={(e) => myError("startage", null, e)}
              birthYear={form.BirthYear}
            />
            <InputSelectMonth
              label="Month"
              name="StartMonth"
              value={form.StartMonth}
              onChange={onChange_t}
              errors={errors}
              onError={(e) => myError("startmonth", null, e)}
            />
          </Stack>
          <Box sx={{ my: 2, p: 2, border: "1px solid grey" }}>
            <Typography id="who" variant="h6" gutterBottom={false}>
              Residency
            </Typography>
            <Stack spacing={2}>
              <InputCheck
                label="Resident Max"
                name="ResidentMax"
                value={form.ResidentMax}
                onChange={(n, v) => {
                  let nf = { ...form, [n]: v, };
                  setForm(nf);
                  onChange(nf);
                }}
              />
              <Stack direction="row" spacing={2}>
                <InputAge
                  label={"Resident Years"}
                  name="ResidentYears"
                  age={form.ResidentYears}
                  min={0}
                  max={40}
                  width={120}
                  onChange={onChange_t}
                  disabled={form.ResidentMax}
                  required={!form.ResidentMax}
                  onError={(e) => myError("residentyears", null, e)}
                />
                <InputAge
                  label={"Agreement Years"}
                  name="AgreementYears"
                  age={form.AgreementYears}
                  min={0}
                  max={40}
                  width={120}
                  onChange={onChange_t}
                  disabled={form.ResidentMax}
                  onError={(e) => myError("agreementyears", null, e)}

                />
              </Stack>
              <Stack spacing={-3} >
                <InputCheck
                  label="Non-Resident collecting OAS"
                  name="NonResident"
                  value={form.NonResident}
                  onChange={onChange_any}
                />
                {/* <InputCheck
                  label="Delay OAS Calculation"
                  name="DelayOASCalculation"
                  value={form.DelayOASCalculation}
                  onChange={onChange_any}
                /> */}
              </Stack>
            </Stack>
          </Box>

        </Stack >
      </Box >
      <Box sx={{ width: 300, my: 2, p: 2, border: "1px solid grey" }}>
        <Stack spacing={2} sx={{ my: 2 }}>
          <Typography id="who" variant="h6" gutterBottom>
            GIS
          </Typography>
          <Stack spacing={-3} >
            <InputCheck
              label="No GIS"
              name="NoGIS"
              value={form.NoGIS}
              onChange={onChange_any}
            />
            <InputCheck
              label="Delay GIS Calculation"
              name="DelayGISCalculation"
              value={form.DelayGISCalculation}
              onChange={onChange_any}
            />
            {/* <Stack spacing={2} sx={{ pt: 4 }}>
              <InputMoney
                xlabel="GIS Income"
                name="GIS Income"
                sx={{ width: 150 }}
                money={form.GISIncome}
                onChange={onChange_t}
                min={0}
                max={100000000}
                onError={(e) => myError("gisincome", null, e)}
              />
            </Stack> */}
          </Stack>
        </Stack>
      </Box >
    </Stack >
  );
};


const CppInput = ({ avail, Cpp, onChange, index, who, onError, onDelete }) => {
  const [form, setForm] = useState(Cpp);
  const [errors, setErrors] = useState({})

  const icon = useRef();
  const gridRef = useRef();
  //useEffect(() => {}, [form]);

  const defaultColDef = {
    field: "",
    editable: true,
    resizable: true,
    suppressMovable: true,
    width: 100,
  };
  const cd_Year = {
    headerName: "Year",
    field: "Year",
    type: "rightAligned",
    width: 90,
    sort: "asc",
    sortable: true,
    cellEditor: 'agNumberCellEditor',
    cellEditorParams: {
      min: 1960,
      max: 2100,
    }
  };
  const cd_UpToAge = {
    headerName: "UpToAge",
    field: "UpToAge",
    type: "rightAligned",
    headerTooltip:
      "Replicate this value up to and including AGE as described in this column",
    width: 95,
    cellEditor: 'agNumberCellEditor',
    cellEditorParams: {
      min: 18,
      max: 120,
    }
  };
  const cd_UPE = {
    headerName: "UPE",
    field: "UPE",
    type: "rightAligned",
    headerTooltip: "Unadjusted Pensionable Earnings for the year",
    width: 120,
    valueFormatter: moneyFormatter,
    cellEditor: 'agNumberCellEditor',
    cellEditorParams: {
      min: 0,
      max: 200000,
    }
  };
  const cd_Max = {
    headerName: "Max",
    field: "Max",
    headerTooltip: "Basic Maximum hit for this year",
    width: 90,
    cellStyle: { placeItems: "center" },
  };
  const cd_EMax = {
    headerName: "CPP2 Max",
    field: "AdditionalMax",
    headerTooltip: "CPP2 Maximum hit for this year",
    width: 105,
    cellStyle: { placeItems: "center" },
  };
  const cd_Dropout = {
    headerName: "Dropout",
    field: "Dropout",
    headerTooltip:
      "Allow this year to be dropped out (for ChildRearing or Disability), this is in Addition to the default number of years MyOwnFP will calculate and drop out",
    //width: 60,
    cellStyle: { placeItems: "center" },
  };
  const cd_Delete = {
    headerName: "Delete",
    field: "",
    editable: false,
    width: 80,
    cellRenderer: DeleteIconRenderer,
    cellRendererParams: {
      callback: (e) => { icon.current = e },
    },
  };

  const DoDelete = (e) => {
    //console.log("DoDelete");
    let deletedRow = e.node.data;
    //console.log(deletedRow);
    gridRef.current.api.applyTransaction({ remove: [deletedRow] });

    // // looks like I have to delete the row myself... (just like the append in the add case)
    console.log(deletedRow.Id)
    let json = form.Annual.slice();
    json = json.filter((o) => o.Id !== deletedRow.Id);
    let nf = {
      ...form,
      Annual: json,
    };
    setForm(nf);
    onChange(nf);
    onDelete()
  };

  const cellClickedListener = (e) => {
    // console.log("cellClicked");
    // console.log(e);
    // console.log(icon.current);
    if (e.colDef.headerName === "Delete") {
      // console.log("ok de col");
      // console.log(icon.current);
      if (icon.current) {
        switch (icon.current) {
          case "go-delete": {
            DoDelete(e);
          }
        }
      }
    }
    //icon.current = "do-nothing";
  };

  const cd_CPP = [
    cd_Year,
    cd_UpToAge,
    cd_UPE,
    cd_Max,
    cd_EMax,
    cd_Dropout,
    cd_Delete,
  ];

  const onChange_t = (e) => {
    let nf = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nf);
    validate(nf)
    onChange(nf);
  };


  const validate = (nf) => {
    if (nf) {
      let ne = structuredClone(errors)

      let pa = Number(nf.PersonalAmount)
      let sa = Number(nf.SurvivorAmount)
      let by = Number(nf.BenefitYear)
      let birth = Number(nf.BenefitYear)

      // console.log(pa)
      // console.log(sa)
      // console.log(by)
      // console.log(nf.BirthYear + 60)
      if ((pa !== 0 || sa !== 0) && by < (nf.BirthYear + 18)) {
        ne = set(ne, "BenefitYear", (nf.BirthYear + 18) + " to " + (nf.BirthYear + 95))
        // console.log(ne)
      } else {
        ne = set(ne, "BenefitYear", "")
        // console.log(ne)
      }

      setErrors(ne)
      console.log(ne)
      if (onError !== null) {
        onError(errorJsonHasErrors(ne) ? "Errors" : "")
      }
    }
  }


  const onCellEditingStopped = (e) => {
    console.log("cell edit stopped:");
    console.log(e);
    console.log(form);
    onChange(form);
  };

  // const onGridReady = useCallback((params) => {
  //   gridRef.current.api.sizeColumnsToFit();
  // }, []);

  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }

  const onAdd = () => {
    let n_ann = {
      Id: 0,
      Year: 0,
      UpToAge: 0,
      UPE: 0,
      Max: false,
      AdditionalMax: false,
      Dropout: false,
      Dropoutmonth: 0,
    };
    let json = [];
    if (form.Annual) {
      json = form.Annual.slice();
      n_ann.Id = Math.max(...form.Annual.map((o) => o.Id), 0) + 1;
      n_ann.Year = Math.max(...form.Annual.map((o) => o.Year), 0) + 1;
    }
    if (n_ann.Year === 1) {
      n_ann.Year = new Date().getFullYear() - 1;
    }
    json.push(n_ann);

    let nf = {
      ...form,
      Annual: json,
    };
    setForm(nf);
    onChange(nf);
  }

  const onRowDataUpdated = useCallback((event) => {
    event.api.autoSizeAllColumns();
  }, []);




  return (
    // <Container maxWidth="true">
    <Box sx={{ my: 2, p: 2, border: "1px solid grey" }}>
      <Stack spacing={2} sx={{ my: 2 }}>
        <Typography id="who" variant="h6" gutterBottom>
          CPP/QPP
        </Typography>
        <Stack spacing={2}>
          <Box>
            <Stack direction="row" spacing={2} >
              <Box>
                <Typography sx={{ mt: 2 }} variant="body2" >
                  Start
                </Typography>
              </Box>
              <InputAge
                label="Age"
                name="StartAge"
                age={form.StartAge}
                min={60}
                max={form.Qpp === true ? 72 : 70}
                onChange={onChange_t}
                onError={(e) => myError("startage", null, e)}
                birthYear={form.BirthYear}

              />
              <InputSelectMonth
                label="Month"
                name="StartMonth"
                value={form.StartMonth}
                onChange={onChange_t}
                errors={errors}
                onError={(e) => myError("startmonth", null, e)}
              />
              <InputCheck
                label="QPP Eligible "
                name="Qpp"
                value={form.Qpp}
                onChange={(n, v) => {
                  let nf = { ...form, [n]: v, };
                  setForm(nf);
                  onChange(nf);
                }}
              />
            </Stack>
          </Box>
          <Stack spacing={2}>
            <Divider sx={{ mt: 0 }}>
              <Chip
                label="Simple Model"
                size="small"
              />
            </Divider>
            <Stack spacing={2}>
              <InputPercentage
                label="Percent"
                name="Percent"
                percent={form.Percent}
                onChange={onChange_t}
                onError={(e) => myError("simplepercent", null, e)}

              />
            </Stack>
            <Divider sx={{ mt: 0 }}>
              <Chip
                label="Existing Benefits Model"
                size="small"
              />
            </Divider>

            <Stack direction="row" spacing={2}>
              <InputYear
                name="BenefitYear"
                year={form.BenefitYear}
                birthYear={form.BirthYear}
                required={false}
                onChange={onChange_t}
                minAge={18}
                maxAge={95}
                errors_={errors}
                width={90}
                onError={(e) => myError("benefityear", null, e)}
              />
              <InputMoney
                xlabel="CPP Yearly Benefit"
                name="PersonalAmount"
                sx={{ width: 150 }}
                money={form.PersonalAmount}
                onChange={onChange_t}
                min={0}
                max={30000}
                onError={(e) => myError("personalamt", null, e)}
              />
              <InputMoney
                xlabel="Survivor Yearly Benefit"
                name="SurvivorAmount"
                sx={{ width: 150 }}
                money={form.SurvivorAmount}
                onChange={onChange_t}
                min={0}
                max={30000}
                onError={(e) => myError("survivoramt", null, e)}
              />
            </Stack>
            <Divider sx={{ mt: 0 }}>
              <Chip
                label="Full Model"
                size="small"
              />
            </Divider>
            <Stack direction="row" spacing={2}>
              <Button
                variant="contained"
                size="small"
                onClick={onAdd}
              >
                Add Row
              </Button>
            </Stack>
            <Stack
              sx={{
                overflow: "scroll",
                display: "inline-flex !important",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                mt: 2,
              }}
            >
              <div style={{ minWidth: 780, width: "100%", height: "100%" }}>
                <div
                  className="ag-theme-alpine"
                  style={{ width: "100%", height: 500 }}
                >
                  <AgGridReact
                    ref={gridRef}
                    rowData={form.Annual} // Row Data for Rows
                    rowHeight={38}
                    columnDefs={cd_CPP} // Column Defs for Columns
                    defaultColDef={defaultColDef} // Default Column Properties
                    tooltipShowDelay={1200}
                    //suppressCellSelection={true}
                    // onGridReady={onGridReady}
                    onCellClicked={cellClickedListener} // Optional - registering for Grid Event
                    onCellEditingStopped={onCellEditingStopped}
                    overlayNoRowsTemplate={"<span>No data</span>"}
                    onRowDataUpdated={onRowDataUpdated}
                    autoSizeStrategy={autoSizeStrategy}
                    autoSizePadding={8}
                    animateRows={false} // Optional - set to 'true' to have rows animate when sorted

                  />
                </div>
              </div>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Box >
  );
};



const GovCreditsInput = ({ avail, credits, onChange, client, onError }) => {
  const [form, setForm] = useState(credits);
  const [errors, setErrors] = useState({})

  useEffect(() => { }, [client]);

  const onChange_t = (e) => {
    let nf = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nf);
    onChange(nf);
  };

  const onChange_any = (n, v) => {
    let nf = { ...form, [n]: v, };
    setForm(nf);
    onChange(nf);
  }

  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }
  console.log(form)

  return (
    <Box sx={{ width: 1227, my: 2, p: 2, border: "1px solid grey" }}>
      <Stack spacing={2} sx={{ my: 2 }}>
        <Typography id="who" variant="h6" gutterBottom>
          Credits
        </Typography>

        <Stack direction="row" spacing={2} >
          <InputSelect1
            label="Credits"
            avail={avail.CreditsIncludesAll}
            name="IncludesAll"
            value={form.IncludesAll}
            onChange={onChange_t}
            errors={errors}
            minWidth={200}
          />
          <InputSelectN
            label="Except"
            avail={avail.Credits}
            name="Except"
            value={form.Except}
            onChange={onChange_t}
            errors={errors}
            minWidth={200}
          />
          <InputCheck
            label="Climate Rural"
            name="ClimateRural"
            value={form.ClimateRural}
            onChange={onChange_any}
            errors={errors}
          />
        </Stack>
      </Stack >
    </Box >
  );


};


const AddGov = ({
  show,
  close,
  client_p,
  clientJson,
  c_callback,
  accountType,
}) => {
  const data = useRef();
  const [form, setForm] = useState();
  const [dataset, setDataset] = useState();
  const [avail, setAvail] = useState([]);
  const [client, setClient] = useState(client_p);
  const [clients, setClients] = useState([client_p]);
  const [errors, setErrors] = useState({})
  const [errmsg, setErrmsg] = useState("")
  const [deleted, setDeleted] = useState(false)



  const getInputData = (client_) => {
    let url = AccountUrl_get(clientJson, "gov", "", empty_uuid, false, "");
    ftchPlus(url, getOptions)
      .then((json) => {
        if (json) {
          data.current = json;
          setForm(json);
          setClients(json.Clients);
          setAvail(json.Avail)
          Update(client_)

          console.log(data.current);
        }
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
      });
  };


  const onDelete = () => {
    setDeleted(true)
  }
  const myClose = () => {
    data.current = null;
    setDataset(null);
    close(accountType);
    setDeleted(false)
  };

  const putRequest = async () => {
    let url = AccountUrl_put(clientJson, "gov", "", empty_uuid, "", false);
    var req = putOptions;
    req.body = JSON.stringify(form);
    ftchPlus(url, req)
      .then((response) => {
        console.log("update completed");
        myClose();
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
      });
  };

  const onSubmit = () => {
    console.log("on submit");
    console.log(form);
    putRequest();

  };

  useEffect(() => {
    if (show) {
      errorClear(errors)
      setErrmsg("")
      getInputData(client_p);
    }
  }, [show]);

  const anyChange = (subpath, any) => {
    console.log("any_change: ");
    console.log(any);
    let json = form;
    let path = "DataSet[" + client + "]." + subpath;
    console.log("Path: " + path);

    json = set(json, path, any);
    setForm(json);
  };

  const cppChange = (cpp) => {
    anyChange("Cpp", cpp);
  };
  const creditsChange = (cpp) => {
    anyChange("Credits", cpp);
  };
  const oasChange = (oas) => {
    anyChange("Oas", oas);
  };
  const infChange = (inf) => {
    anyChange("Inf", inf);
  };
  const taxChange = (tax) => {
    anyChange("Tax", tax);
  };

  const Update = (cl) => {
    setClient(cl);
    setDataset(data.current.DataSet[cl]);
  }



  const onClientChanged = (cl) => {
    Update(cl);
  };


  const myError = (obj, i, err) => {
    errorSet(errors, setErrors, obj, i, err)
  }

  return (
    <>
      <AddDialog
        clientJson={clientJson}
        c_callback={c_callback}
        onClose={myClose}
        open={show}
        clients={clients}
        client={client}
        label="Government Benefits"
        accountType={accountType}
        onClientChange={onClientChanged}
        onSubmit={onSubmit}
        errors={errors}
        errmsg={errmsg}
        deleted={deleted}

      >
        {data !== null &&
          dataset !== undefined &&
          dataset !== null && (
            <Stack sx={{ my: 2, mx: 4 }}>


              <Stack direction="row" spacing={2}>
                <Stack spacing={2}>
                  <OASInput
                    key={"oas-input" + client}
                    Oas={dataset.Oas}
                    onChange={oasChange}
                    onError={(e) => myError("oas", null, e)}
                  />
                  <InfInput
                    Inf={dataset.Inf}
                    onChange={infChange}
                    onError={(e) => myError("inf", null, e)}
                  />
                </Stack>
                <CppInput
                  key={"cpp-input" + client}
                  Cpp={dataset.Cpp}
                  onChange={cppChange}
                  onError={(e) => myError("cpp", null, e)}
                  onDelete={onDelete}
                />
              </Stack>
              <GovCreditsInput
                key={"cred-input" + client}
                avail={avail}
                credits={dataset.Credits}
                onChange={creditsChange}
                onError={(e) => myError("credits", null, e)}
              />
              {dataset.Tax && (
                <TaxInput
                  key={"tax-input" + client}
                  Tax={dataset.Tax}
                  birthYear={dataset.Cpp.BirthYear}
                  onChange={taxChange}
                  onError={(e) => myError("tax", null, e)}
                />
              )}
            </Stack>
          )}
      </AddDialog>
    </>
  );
};

export default AddGov;
